<div class="import-field-overlay-bg">
  <div class="import-field-overlay-container">
    <div class="import-header">
      <div class="import-headline">
        {{ "import.headline" | translate }}
      </div>
      <div class="close-btn">
        <img
          [src]="'../../assets/images/common/icon_close.svg'"
          alt="icon close"
          role="button"
          (click)="onCancel()"
          class="cursor-pointer"
          />
        </div>
      </div>
      <div class="separator"></div>
      @if (hasErrors$ | async) {
        <div class="error-message-box">
          @for (fileError of (fileParsingErrors$ | async); track fileError) {
            <div class="error-message">
              <mat-icon class="error-icon">error</mat-icon>
              <span>{{ fileError.filename }}: {{ fileError.errorMessage }}</span>
            </div>
          }
          @for (field of (fieldOptions$ | async); track field) {
            <div class="error-message">
              @if (field.hasError) {
                <mat-icon class="error-icon">error</mat-icon>
              }
              @if (field.hasError) {
                <span>{{ field.field.name }}: {{ field.errorMessage }}</span>
              }
            </div>
          }
        </div>
      }
      <div class="import-body">
        <!-- page 1 -->
        @if (!(fieldsLoaded$ | async) && (fieldOptions$ | async)?.length == 0) {
          <div
            class="page1"
            >
            <div class="btn-import-toggle">
              <mat-button-toggle-group
                name="importHandler"
                [value]="defaultImportType"
                (change)="onToggleImportHandler($event)"
                >
                <mat-button-toggle value="IsoXML">{{
                  "import.type.isoxml.label" | translate
                }}</mat-button-toggle>
                <mat-button-toggle value="ShapeFile">{{
                  "import.type.shapefile.label" | translate
                }}</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div class="field-simplification">
              <div class="simplify-text">
                <label>
                  {{ "import.message.simplification.label" | translate }}
                </label>
              </div>
              <label for="simplify"></label>
              @if (!hasImportStarted) {
                <input
                  type="checkbox"
                  id="simplify"
                  name="simplify_borders"
                  value="simplify_borders"
                  [checked]="simplifyBorders"
                  [disabled]="files.length != 0"
                  (change)="onSimplification()"
                  />
              }
              <br />
            </div>
            <div class="import-field-drag-and-drop">
              <div
                id="dropzone"
                class="dropzone"
                appDropzone
                (onFileDropped)="droppedFiles($event)"
                (click)="fileInput.click()"
                >
                {{ "import.btn.file.drop" | translate }}
                <input
                  #fileInput
                  type="file"
                  multiple
                  (change)="onFileSelect($event)"
                  style="display: none"
                  />
                </div>
                @if (files.length != 0) {
                  <div class="files-list">
                    @for (selectedFile of files; track selectedFile) {
                      <div class="selected-files">
                        <button mat-button (click)="removeFile(selectedFile)">
                          <img
                            [src]="'../../assets/images/common/icon_close.svg'"
                            alt="icon close"
                            class="cursor-pointer"
                            />
                          </button>
                          <div class="file-names">
                            {{ selectedFile.name }}
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <!-- page 2 -->
            @if (fieldsLoaded$ | async) {
              <div class="page2">
                <!-- content -->
                @if ((fieldOptions$ | async)?.length != 0) {
                  <div
                    class="import-field-list"
                    >
                    <!-- field list header-->
                    <div class="field-list-header-entry">
                      <div class="field-info">
                        <label class="field-selection">
                          {{ "import.message.selection.label" | translate }}
                        </label>
                      </div>
                      <label style="margin: auto">
                        @if (!hasImportStarted) {
                          <input
                            type="checkbox"
                            id="i"
                            name="select_all"
                            value="select_all"
                            [checked]="selectAll"
                            (change)="onUnselectAll()"
                            />
                        }
                      </label>
                      <br />
                    </div>
                    <!-- field list -->
                    @for (option of fieldOptions$ | async; track option; let i = $index) {
                      <div
                        class="field-list-entry"
                        >
                        <img
                          class="field-marker"
                          src="/assets/images/marker/icon_marker_field.svg"
                          width="22px"
                          height="22px"
                          alt="field"
                          />
                          <div class="field-info">
                            <label class="field-name" for="{{ option.field.id }}">
                              {{ option.field.name }}</label
                              >
                              <label class="field-size" for="{{ option.field.id }}">
                                {{ option.field.area.toFixed(2) }} ha</label
                                >
                              </div>
                              <label class="form-control">
                                @if (!hasImportStarted) {
                                  <input
                                    type="checkbox"
                                    id="i"
                                    name="{{ option.field.id }}"
                                    value="{{ option.field.id }}"
                                    [checked]="option.selected"
                                    (change)="onFieldSelect(option)"
                                    />
                                }
                              </label>
                              <br />
                              @if (option.isImported) {
                                <label for="{{ option.field.id }}">
                                  <img
                                    src="\assets\images\common\icon_success_import.svg"
                                    width="24px"
                                    height="24px"
                                    alt="field_success_import"
                                  /></label>
                                }
                              </div>
                            }
                          </div>
                        }
                        <!-- no content -->
                        @if ((fieldOptions$ | async)?.length == 0) {
                          <div>
                            <div class="import-field-text">
                              <span class="import-error-text"
                                >{{ "import.message.loading.error" | translate }}
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>

                  <div class="import-footer">
                    <!-- page 1 footer -->
                    <div class="import-btns">
                      @if (
                        !(fieldsLoaded$ | async) && (fieldOptions$ | async)?.length == 0
                        ) {
                        <div
                          >
                          <button class="btn-large btn-blue-primary" (click)="onUpload()">
                            <span>{{ "import.btn.confirm.label" | translate }}</span>
                          </button>
                        </div>
                      }
                    </div>

                    <!-- page 2 footer -->
                    @if (
                      (fieldsLoaded$ | async) &&
                      (fieldOptions$ | async)?.length != 0 &&
                      !hasImportStarted
                      ) {
                      <div
                        class="import-btns"
                        >
                        <button class="btn-small btn-blue-secondary" (click)="onReset()">
                          {{ "import.btn.reset.label" | translate }}
                        </button>
                        <button
                          class="btn-small btn-blue-primary"
                          (click)="onImport()"
                          [disabled]="selectedFieldsCount === 0"
                          >
                          {{ "import.btn.confirm.label" | translate }}
                        </button>
                      </div>
                    }

                    <!-- page 2.1 import empty footer -->
                    @if ((fieldsLoaded$ | async) && (fieldOptions$ | async)?.length == 0) {
                      <div
                        class="import-btns"
                        >
                        <button class="btn-small btn-blue-secondary" (click)="onCancel()">
                          {{ "import.btn.cancel.label" | translate }}
                        </button>
                        <button class="btn-small btn-blue-primary" (click)="onReset()">
                          {{ "import.btn.reset.label" | translate }}
                        </button>
                      </div>
                    }

                    <!-- page 2.2 import finished footer -->
                    @if (hasImportStarted) {
                      <div>
                        <div class="import-success-text">
                          <label
                            >{{ "import.message.importing.success" | translate }}
                            {{ succesfulImported }} / {{ selectedFieldsCount }}
                          </label>
                          <mat-progress-bar
                            style="width: 343px"
                            mode="determinate"
                            [value]="currentProgress"
                          ></mat-progress-bar>
                        </div>
                        @if (isImportFinished && hasError) {
                          <button
                            class="btn-large btn-blue-primary"
                            (click)="onClose()"
                            >
                            {{ "import.btn.finished.label" | translate }}
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
